exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.required-feedback[data-v-4e15878b]{width:100%;margin-top:.25rem;font-size:.875em;color:#dc3545\n}\n.shake[data-v-4e15878b]{animation:shake-data-v-4e15878b .82s;transform:translate3d(0, 0, 0)\n}\n@keyframes shake-data-v-4e15878b{\n10%,90%{transform:translate3d(-1px, 0, 0)\n}\n20%,80%{transform:translate3d(2px, 0, 0)\n}\n30%,50%,70%{transform:translate3d(-4px, 0, 0)\n}\n40%,60%{transform:translate3d(4px, 0, 0)\n}\n}", ""]);

// exports
